import React from 'react';
import { Column } from 'components/Grid';
import styled from 'styled-components';
import { Breakpoint } from 'au-gatsby-ds/helpers/Breakpoint';

const SpacerContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6em;
`;

const Spacer = styled.hr`
  width: 40px;
  border: 1px solid black;
  opacity: 0.48;
  
  @media ${Breakpoint.medium} {
    font-size: 40px;
  }
`;

const Headline = styled.h1`
  font-family: Crimson Text, sans-serif;
  font-weight: 200;
  line-height: 1.1;
  letter-spacing: 0px;
  text-align: center;
  padding: 1em;
  font-size: 32px;
  
  @media ${Breakpoint.medium} {
    font-size: 40px;
  }
`;

export const HomeH1 = (): JSX.Element => {
  return (
    <Column id="home-h1" size={12}>
      <SpacerContainer>
        <Spacer/>
      </SpacerContainer>
      <Headline>Custom Photo Books, Prints, Frames & Gifts</Headline>
    </Column>
  );
};

